import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

const PRIORITY_CONFIG: Record<string, { classes: string }> = {
  URGENT: { classes: 'bg-red-100 text-red-800 border-red-300' },
  HIGH: { classes: 'bg-red-50 text-red-700 border-red-200' },
  NORMAL: { classes: 'bg-amber-50 text-amber-600 border-amber-200' },
  LOW: { classes: 'bg-slate-50 text-slate-500 border-slate-200' },
};

interface PriorityBadgeProps {
  priority: string;
  className?: string;
}

export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const { t } = useTranslation('common');
  const config = PRIORITY_CONFIG[priority] || {
    classes: 'bg-slate-50 text-slate-600 border-slate-200',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider',
        config.classes,
        className
      )}
    >
      {t(`priority.${priority}`, { defaultValue: priority })}
    </span>
  );
}
